import { getTimeFromNow } from 'utils/3catinfo/dateHelper';
import { dataResources } from 'utils/constants';
import Image from 'next/image';
import Imatge from 'components/3catinfo/Imatge';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import styles from './cameraEmbed.module.scss';

const { basePath } = dataResources;
const imageLoader = ({ src }) => {
    return `${src}`;
};

const CameraEmbed = (props) => {
    const { item } = props;
    const dadesCam = item;

    if (__isEmpty(dadesCam)) return <></>;
    const { nom } = item;
    const { temperatura_actual, snapshots, forca_vent, humitat, data_creacio } = dadesCam;

    const dataActualitzacio = data_creacio ? getTimeFromNow(moment(data_creacio * 1000).format('DD/MM/YYYY HH:mm:ss')) : null;

    const getQualitatSenseDades = (qualitat) => (qualitat ?? '').replace('--', 'sense_dades') || 'sense_dades';
    const qualitat_pm10 = getQualitatSenseDades(dadesCam.qualitat_pm10);
    const qualitat_no2 = getQualitatSenseDades(dadesCam.qualitat_no2);
    const qualitat_o3 = getQualitatSenseDades(dadesCam.qualitat_o3);

    return (
        <div className={styles.cameraEmbed}>
            <div className={styles.contentImatge}>
                <div className={styles.capcalera}>
                    <Image
                        loader={imageLoader}
                        unoptimized={true}
                        width={119}
                        height={24}
                        alt='3CatInfo'
                        src={basePath + '/_resources/logos/3catinfo.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </div>
                {snapshots?.[1].fitxer && (
                    <div className={styles.imatgeWrapper}>
                        <Imatge
                            className={styles.imatge}
                            src={`https://statics.3cat.cat${snapshots?.[1].fitxer}`}
                            width='670'
                            height='378'
                            alt={nom}
                            aria-hidden='true'
                            objectFit='cover'
                        />
                    </div>
                )}
                <div className={styles.info}>
                    <div className={styles.dades}>
                        <span className={styles.temperatura}>{temperatura_actual}º</span>
                        <span className={styles.humitat}>{humitat}% </span>
                    </div>
                    <div className={styles.qualitats}>
                        <Imatge
                            src={`${basePath}/_resources/imatges/3catinfo/cameres/pm10_${qualitat_pm10}.svg`}
                            alt={`Qualitat PM10 ${qualitat_pm10.replace('_', ' ')}`}
                            width={32}
                            height={32}
                        ></Imatge>
                        <Imatge
                            src={`${basePath}/_resources/imatges/3catinfo/cameres/no2_${qualitat_no2}.svg`}
                            alt={`Qualitat NO2 ${qualitat_no2.replace('_', ' ')}`}
                            width={32}
                            height={32}
                        ></Imatge>
                        <Imatge
                            src={`${basePath}/_resources/imatges/3catinfo/cameres/o3_${qualitat_o3}.svg`}
                            alt={`Qualitat O3 ${qualitat_o3.replace('_', ' ')}`}
                            width={32}
                            height={32}
                        ></Imatge>
                    </div>
                </div>
            </div>
            <div className={styles.contentTitle}>
                <div className={styles.title}>{nom}</div>
                {dataActualitzacio && (
                    <div className={styles.contentDate}>
                        <Icona className={styles.ico_clock} icona='rellotge' color='blanc' mida='20' alt='Temps' />
                        <span className={styles.date} suppressHydrationWarning>
                            {dataActualitzacio}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CameraEmbed;
